import React, { useState } from 'react';
import { Box, Button, Checkbox, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import { ViewColumnOutlined as ColumnsIcon } from '@mui/icons-material';
import { ColumnId, TABLE_COLUMNS } from '../constants';

interface Props {
  visible: ColumnId[];
  isDefault: boolean;
  onToggle: (id: ColumnId) => void;
  onReset: () => void;
}

/** Выбор видимых колонок таблицы (обязательные колонки скрыть нельзя) */
const ColumnsMenu: React.FC<Props> = ({ visible, isDefault, onToggle, onReset }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      <Tooltip title="Колонки таблицы">
        <Button
          size="small" color="inherit" onClick={e => setAnchor(e.currentTarget)} startIcon={<ColumnsIcon sx={{ fontSize: 18 }} />}
          sx={{ textTransform: 'none', fontSize: '0.78rem', color: '#475569', height: 30, borderRadius: 1.5 }}
        >
          Колонки: {visible.length} из {TABLE_COLUMNS.length}
        </Button>
      </Tooltip>
      <Menu
        anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { maxHeight: 480, minWidth: 240, borderRadius: 2 } }}
      >
        <Box sx={{ px: 2, py: 0.75 }}>
          <Typography sx={{ fontSize: '0.74rem', color: 'text.secondary' }}>Набор колонок запоминается в этом браузере</Typography>
        </Box>
        <Divider />
        {TABLE_COLUMNS.map(col => {
          const checked = visible.indexOf(col.id) !== -1;
          return (
            <MenuItem key={col.id} dense disabled={col.required} onClick={() => onToggle(col.id)} sx={{ py: 0.25 }}>
              <ListItemIcon sx={{ minWidth: 34 }}>
                <Checkbox size="small" checked={checked} disableRipple sx={{ p: 0.5 }} />
              </ListItemIcon>
              <ListItemText
                primary={col.label} secondary={col.required ? 'всегда видна' : undefined}
                primaryTypographyProps={{ fontSize: '0.82rem' }} secondaryTypographyProps={{ fontSize: '0.68rem' }}
              />
            </MenuItem>
          );
        })}
        <Divider />
        <MenuItem dense disabled={isDefault} onClick={onReset} sx={{ fontSize: '0.8rem', color: 'primary.main', justifyContent: 'center' }}>
          Вернуть набор по умолчанию
        </MenuItem>
      </Menu>
    </>
  );
};

export default React.memo(ColumnsMenu);
